import "./FaqMenuCard.css";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import { Button, Divider, Grid, Paper } from "@material-ui/core";
import FaqMenuTypeList from "./FaqMenuTypeList";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FaqMenuTypeUrl from "./FaqMenuTypeUrl";
import FaqMenuTypeListContent from "./faq_menu/faq_menu_types/FaqMenuTypeListContent";
import FaqMenuTypeListHeaderString from "./faq_menu/faq_menu_types/FaqMenuTypeListHeaderString";
import FaqMenuTypeHFString from "./faq_menu/faq_menu_types/FaqMenuTypeListHFString";

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "white",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function FaqMenuCard(props) {
  // const classes = useStyles();
  // console.log("FaqMenuCard Entered");
  // console.log("FAQ Data: ", props.onFaqMenuData);
  // console.log(
  //   "FAQ Data to map: ",
  //   props.onFaqMenuData.BODY.details.data.collection.faq
  // );

  let faqData = props.onFaqMenuData.BODY.details.data.collection;
  // console.log("faqData collection: ", faqData);
  let faqUrl = props.onFaqMenuData.BODY.details.url;
  let title = props.onFaqMenuData.BODY.details.title;

  const [expanded, setExpanded] = React.useState();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div className="faq-menu-wrapper faq-menu-wrapper-bot faq-menu-wrapper-border faq-menu-width-70" style={{border:"1px solid rgba(255, 197, 95, 1)"}}>
      <Grid item xs>
        <Typography
          variant="button"
          display="block"
          align="center"
          gutterBottom
          className="title"
        >
          {title}
          {/* <h5 className="hero_card_title">{this.props.herocardData.title}</h5> */}
        </Typography>
      </Grid>
      <Divider variant="middle" />
      <Paper>
        {faqData.faq.map((data, i) => (
          <Accordion square key={i}>
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  expanded={expanded == `${i}`}
                  onChange={handleChange(`${i}`)}
                />
              }
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography>{data.question}</Typography>
            </AccordionSummary>
            {/* Based on Types */}
            {data.targetType == "string" && (
              <AccordionDetails>
                <Typography>{data.answer}</Typography>
              </AccordionDetails>
            )}
            {data.targetType == "list_string" && (
              <FaqMenuTypeList faqListData={data.answer} />
            )}
            {data.targetType == "list_url" && (
              <FaqMenuTypeUrl faqUrlData={data.answer} />
            )}
            {data.targetType == "list_content_string" && (
              <FaqMenuTypeListContent faqListContentData={data.answer} />
            )}
            {data.targetType == "list_header_string" && (
              <FaqMenuTypeListHeaderString faqListHeaderStrData={data.answer} />
            )}
            {data.targetType == "list_header_footer_string" && (
              <FaqMenuTypeHFString faqlistHFStrData={data.answer} />
            )}
          </Accordion>
        ))}
      </Paper>
      <Grid item className="grid-btn">
        <Typography
          variant="caption"
          display="block"
          gutterBottom
          className="typography_link_center"
        >
          <Button
            variant="outlined"
            size="small"
            href={faqUrl}
            target="_blank"
          >
            Click For More
          </Button>
        </Typography>
      </Grid>
    </div>
  );
}
